<template>
   <svg viewBox="0 0 63 54" fill="none" stroke="currentColor" aria-hidden="true" focusable="false">
      <path d="M18.5258 0.652588H44.3776L61.6094 26.5045L44.3776 52.348H18.5258L1.29395 26.5045L18.5258 0.652588Z" />
   </svg>
</template>
